(function ($) {
    "use strict";

    $.fn.makeItemsSortable = function(list, morphEntityName, nextUrl, previousUrl, moveTo, options) {

        let _this = $(this);
        let settings = $.extend({
            connectWith: ".connected-sortable",
            placeholder: "ui-state-highlight bg-secondary",
            forcePlaceholderSize: true,
            cursor: "move",
            cancel: ".ui-state-disabled",
            sortUrl: "/sort",
            perPage: 20,
            lastPage: 1,
            currentPage: 1
        }, options );


        $.fn.doSortRequest = function (list, moveTo) {
            $.map($(list).find('tr.ui-sortable-handle'), function(el) {

                let swapSortingValue = 0;
                let perPage = settings.perPage;
                let pageOffset = settings.lastPage - settings.currentPage + 1;
                let sortValue = (pageOffset * perPage) - $(el).index();

                switch (moveTo) {
                    case 'next':
                        pageOffset -= 1;
                        sortValue = (pageOffset * perPage); // place on first (0) position in list of next page
                        swapSortingValue = sortValue + 1;
                        break;
                    case 'previous':
                        pageOffset += 1;
                        sortValue = (pageOffset * perPage) - (perPage-1); // place on last position of previous page
                        swapSortingValue = sortValue - 1;
                        break;
                }

                $.ajax({
                    cache : false,
                    data: {
                        entityClass: morphEntityName,
                        id: el.getAttribute('data-sortable-id'),
                        sorting: (-1 * sortValue),
                        swap: (-1 * swapSortingValue)
                    },
                    dataType: 'JSON',
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    },
                    type: 'POST',
                    url: settings.sortUrl
                }).done(function() {
                    if (nextUrl && moveTo === 'next') { top.location = nextUrl; }
                    if (previousUrl && moveTo === 'previous') { top.location = previousUrl; }
                    return true;
                });
            });
        };

        if (moveTo) {
            settings.receive = function() {
                $('connected-sortable').sortable('disable');
                _this.doSortRequest(list, moveTo);
            };
        }
        else {
            settings.stop = function() {
                if ($(this).find('tr.ui-sortable-handle').length === settings.perPage) {
                    _this.doSortRequest(list, '');
                }
            };
        }
        $(list).sortable(settings).disableSelection();
    }
}(jQuery));
